import styled from "styled-components"

export const StyledTrophyWrapper = styled.div`
  margin-right: ${({theme}) => theme.spacing.half};
`
